import React, { ButtonHTMLAttributes, FC } from "react";
import { Link, LinkProps } from "react-router-dom";
import { LocationStates } from "routers/types";
import Loading from "shared/Loading";
import twFocusClass from "utils/twFocusClass";

export interface ButtonProps {
	className?: string;
	translate?: string;
	sizeClass?: string;
	fontSize?: string;
	success?: boolean;
	successMessage?: string;
	//
	loading?: boolean;
	disabled?: boolean;
	type?: ButtonHTMLAttributes<HTMLButtonElement>["type"];
	href?: keyof LocationStates | "#" | LinkProps["to"];
	targetBlank?: boolean;
	onClick?: () => void;
}

const Button: FC<ButtonProps> = ({
	className = "text-neutral-700 dark:text-neutral-200",
	translate = "",
	sizeClass = "px-4 py-3 sm:px-6",
	fontSize = "text-sm sm:text-base font-medium",
	disabled = false,
	href,
	children,
	targetBlank,
	type,
	loading,
	success = false,
	successMessage,
	onClick = () => {},
}) => {
	successMessage = success ? successMessage : "";
	const CLASSES =
		`nc-Button relative h-auto inline-flex items-center justify-center rounded-full transition-colors ${fontSize} ${sizeClass} ${translate} ${className} ${
			success &&
			"bg-green-400 hover:bg-green-500 focus:offset-none focus:ring-0 dark:bg-green-400 font-bold"
		}` + twFocusClass(true);

	if (!!href) {
		return (
			<Link
				to={href}
				target={targetBlank ? "_blank" : undefined}
				className={`${CLASSES} `}
				onClick={onClick}
				rel="noopener noreferrer"
			>
				<button>
					{" "}
					{successMessage ? successMessage : children || `This is Link`}
				</button>
			</Link>
		);
	}

	return (
		<button
			disabled={disabled || loading}
			className={`${CLASSES}`}
			onClick={onClick}
			type={type}
		>
			{loading && <Loading />}
			{successMessage ? successMessage : children || `This is Button`}
		</button>
	);
};

export default Button;
